var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('progress-bar',{attrs:{"type":"large","progress":_vm.currentProgress,"limit":_vm.maxThreshold,"steps":_vm.steps,"bar-tooltip":_vm.barTooltip}}),_c('div',{staticClass:"text-center text-sm mt-2"},[_c('strong',[_vm._v(_vm._s(_vm.progressDisplay))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }